import { cn } from "@/utils/cn";
import { CSSProperties, memo } from "react";

interface SmileIconProps {
  className?: string;
  style?: CSSProperties;
}

export const SmileIcon = memo(function SmileIcon({ className, style }: SmileIconProps) {
  return (
    <svg
      width="192"
      height="192"
      viewBox="0 0 192 192"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-[168px] w-[168px] overflow-visible fill-current", className)}
      style={{ overflow: "visible", ...style }}
    >
      <g filter="url(#filter0_d_561_810)">
        <g filter="url(#filter1_i_561_810)">
          <circle cx="96" cy="88" r="84" fill="#FBFBFB" />
          <circle cx="96" cy="88" r="84" fill="#E6E6E6" />
        </g>
        <mask
          id="mask0_561_810"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="12"
          y="4"
          width="168"
          height="168"
        >
          <circle cx="96" cy="88" r="84" fill="#760000" />
        </mask>
        <g mask="url(#mask0_561_810)">
          <g filter="url(#filter2_f_561_810)">
            <ellipse cx="79.7301" cy="54.7976" rx="67.7301" ry="50.7976" fill="#E6E6E6" />
            <ellipse cx="79.7301" cy="54.7976" rx="67.7301" ry="50.7976" fill="white" />
          </g>
        </g>
        <path
          d="M133.259 49.1233V67.1336C133.259 73.4946 128.309 78.915 121.948 79.1377C115.278 79.3687 109.8 74.0308 109.8 67.4141V49.1233C109.8 47.4114 111.19 46.0212 112.902 46.0212H112.931C114.642 46.0212 116.033 47.4114 116.033 49.1233V66.156C116.033 66.75 116.441 67.3028 117.027 67.3976C117.773 67.5214 118.421 66.948 118.421 66.2178V49.1233C118.421 47.4114 119.811 46.0212 121.523 46.0212C123.235 46.0212 124.625 47.4114 124.625 49.1233V66.156C124.625 66.75 125.034 67.3028 125.619 67.3976C126.366 67.5214 127.014 66.948 127.014 66.2178V49.1233C127.014 47.4114 128.404 46.0212 130.116 46.0212H130.153C131.869 46.0212 133.259 47.4114 133.259 49.1233Z"
          fill="black"
        />
        <path
          d="M147.553 109.932C141.546 117.82 133.799 124.3 124.877 128.817C122.039 130.253 119.085 131.49 116.02 132.509C113.339 133.4 110.587 134.126 107.762 134.671C107.564 134.642 107.362 134.617 107.164 134.601C107.254 134.65 107.337 134.691 107.419 134.737C103.459 135.483 99.3712 135.875 95.1925 135.875C93.3774 135.875 91.5912 135.805 89.8133 135.653C81.1299 134.951 72.9127 132.563 65.5039 128.817C56.5895 124.3 48.8384 117.82 42.8281 109.932C41.8299 108.621 42.0815 106.744 43.3974 105.745C44.7133 104.739 46.5861 104.999 47.5927 106.306C53.0543 113.476 60.1042 119.375 68.2059 123.475C76.3159 127.58 85.4695 129.89 95.1883 129.89C104.899 129.89 114.061 127.58 122.167 123.475C130.277 119.375 137.322 113.476 142.788 106.306C143.786 104.995 145.667 104.739 146.975 105.745C148.303 106.744 148.555 108.625 147.553 109.932Z"
          fill="black"
        />
        <path
          d="M79.0917 62.6048C79.1114 53.4577 74.5509 46.0325 68.9054 46.0204C63.2599 46.0082 58.6673 53.4135 58.6476 62.5607C58.6278 71.7078 63.1884 79.1329 68.8339 79.1451C74.4794 79.1573 79.0719 71.7519 79.0917 62.6048Z"
          fill="black"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_561_810"
          x="0"
          y="0"
          width="192"
          height="192"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_561_810" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_561_810"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_i_561_810"
          x="12"
          y="4"
          width="168"
          height="172"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_561_810" />
        </filter>
        <filter
          id="filter2_f_561_810"
          x="0"
          y="-8"
          width="159.46"
          height="125.595"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="6" result="effect1_foregroundBlur_561_810" />
        </filter>
      </defs>
    </svg>
  );
});
